import React, { useEffect, useMemo, useState } from 'react'
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';
import { getAccessList } from '../../../api/api.global';
import { ACCESS_LIST } from '../../../statics/localStorage';
import { IconCheck, IconX } from '@tabler/icons-react';
import CreateNewAccessPresetModal from './CreateNewAccessPresetModal';
import UpdateAccessPreset from './UpdateAccessPreset';
import { accessCheck } from '../../../utils/accessCheck';
import { accessKeys } from '../../../statics/accessKeys';

const AccessTab = () => {

    const [accessPresets, setAccessPresets] = useState([]);
    const [selectedPreset, setSelectedPreset] = useState(null);

    let localList = ACCESS_LIST();

    const accessList = useMemo(() => localList?.reduce((acc, item) => {
        acc[item.group] = acc[item.group] || [];
        acc[item.group].push(item);
        return acc;
    }, {}), [localList])

    async function getAccessPresets(presetToBeSelected) {
        loadingShow();
        let resp = await getApi(urlApi.accessPresetList);
        loadingHide();
        if (resp.responseCode === 200) {
            setAccessPresets(resp.data);
            let localData = presetToBeSelected == "EDITED" ? resp?.data?.find(data => data._id === selectedPreset?._id) : null;
            setSelectedPreset(presetToBeSelected == "NEW" ? resp?.data[resp?.data?.length - 1] : presetToBeSelected == "EDITED" ? localData : resp?.data[0]);
        } else {
            toast.error(resp.message);
        }
    }

    useEffect(() => {
        if (accessCheck(accessKeys?.viewAccessPresets)) {
            getAccessPresets(null);
        }
        getAccessList();
        return () => {

        };
    }, []);

    return (
        <div>
            <div className="flex items-center justify-between mb-3">
                <p className='text-[16px] font-semibold mb-0'>Access Presets</p>
                {accessCheck(accessKeys?.createAndEditPreset) && <CreateNewAccessPresetModal buttonComponent={<button className='primary-btn'>Create New Preset</button>
                } accessList={accessList} defaultName={'new preset ' + (accessPresets?.length + 1)} callback={() => getAccessPresets("NEW")} defaultSelectedCodes={[]} />}
            </div>

            {accessCheck(accessKeys?.viewAccessPresets) && <div className="flex flex-wrap gap-3">
                {accessPresets.map((preset, index) => (
                    <div key={index} className={`border-2 rounded-md px-4 py-2 cursor-pointer ${selectedPreset?._id == preset?._id ? 'bg-primary text-white border-primary' : 'bg-transparent'}`} onClick={() => setSelectedPreset(preset)}>
                        <p className="text-sm font-medium">{preset?.name}</p>
                    </div>
                ))}
            </div>}

            {
                accessCheck(accessKeys?.viewAccessPresets) && (selectedPreset &&
                    <div>
                        <div className="flex items-center justify-between my-3">
                            <p className='text-[16px] font-semibold mb-0'>Selected Access Preset</p>
                            {
                                accessCheck(accessKeys?.createAndEditPreset) && (selectedPreset?.isGlobal ?
                                    <CreateNewAccessPresetModal buttonComponent={<button className='primary-btn'> Clone & Create New Preset</button>} accessList={accessList} defaultName={selectedPreset?.name + ' - copy'} callback={() => getAccessPresets("NEW")} defaultSelectedCodes={selectedPreset?.accessCodes} /> :
                                    <UpdateAccessPreset accessList={accessList} accessPresetData={selectedPreset} callback={() => getAccessPresets("EDITED")} />)
                            }

                        </div>

                        <div className='px-4'>
                            {
                                Object.entries(accessList).map(([key, value]) => (
                                    <div key={key} className="mb-4">
                                        <p className="text-sm font-medium">{key}</p>
                                        <div className='ps-4 mt-2 flex flex-wrap items-center gap-3'>
                                            {

                                                value?.map((access, index) => (
                                                    <div key={index} className={`flex items-center border-2 px-3 py-1 rounded-lg text-sm gap-1 ${selectedPreset?.accessCodes?.includes(access?.code) ? 'border-green-500' : 'border-red-500'}`}>
                                                        {access?.name} {selectedPreset?.accessCodes?.includes(access?.code) ? <IconCheck size={18} stroke={4} className='text-green-800' /> : <IconX size={18} className='text-red-800' stroke={4} />}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>)
            }
        </div>
    )
}

export default AccessTab